import { safeOverflowText } from './overflowDetail'
export const copyFieldKey = (column:any):string => Array.isArray(column.dataIndex)?column.dataIndex.join('.'):String(column.dataIndex || column.key || '')
export function isProductIdentifier(column:any):boolean {
  return /^(code|productCode|patternCode|bokeCode|styleCode|goodsCode|productNo|styleNo)$/i.test(copyFieldKey(column)) || /^(版型号|款号|货号|成衣型号)$/.test(String(column.title || ''))
}
export function isCopyField(column:any):boolean {
  return isProductIdentifier(column) || /^(orderNumber|orderNumbers|orderId|requestNumber|demandNumber|batchNumber|trackingNumber|trackingNo|logisticsCode|postCode|waybillNo|courierNo|cellphone|cellPhone|customerPhone|contactPhone|phone|telephone|mobile|loginName|styleLink|styleDetailLink|detailLink|link|url|addressDetails|deliveryAddress|contactAddress)$/i.test(copyFieldKey(column))
}
export function isPhoneCopyField(column:any,value:unknown):boolean {
  const key=copyFieldKey(column)
  return /(phone|mobile|tel)/i.test(key) || /^loginName$/i.test(key) && /^[+\d\s*()-]{7,}$/.test(String(value ?? ''))
}
export function copyFieldValue(value:unknown,column:any,canViewPhone:boolean):string {
  if(value==null || typeof value==='object' || typeof value==='boolean' || isPhoneCopyField(column,value) && !canViewPhone)return ''
  return safeOverflowText(value,copyFieldKey(column),canViewPhone).trim()
}
export function identifierWidth(rows:any[],column:any,measured?:number):number {
  if(measured && measured>0)return Math.ceil(measured)
  const key=copyFieldKey(column),strings=[String(column.title || ''),...rows.map(row=>String(row[key] ?? ''))]
  const width=(value:string)=>Array.from(value).reduce((sum,char)=>sum+(char.charCodeAt(0)>255?13:7.5),0)
  return Math.ceil(Math.max(28,...strings.map(width))+32)
}
